module.exports = __webpack_public_path__ + "media/src/images/app_icons/favicons/ms-icon-70x70-bc0c72c36ee8592570673cbefb007a82.png";